import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getGiros, getEstados } from '../../actions/TablaBuquesAnunciadosActions'
import TablaBuquesAnunciadosView from '../../components/anunciobuques/TablaBuquesAnunciadosView'
import { obtenerCargasBuque } from '../../actions/TablaCargaBuquesActions'

const TablaBuquesAnunciados = (props) => {
  useEffect(() => {
    async function getData () {
      props.getGiros()
      props.getEstados()
      props.obtenerCargasBuque()
    }
    getData()
  }, [props])

  return (
    <>
      <TablaBuquesAnunciadosView />
    </>
  )
}

const mapActionsToProps = {
  getGiros,
  getEstados,
  obtenerCargasBuque
}

export default connect(null, mapActionsToProps)(TablaBuquesAnunciados)
